import { render, staticRenderFns } from "./NPLRatio.vue?vue&type=template&id=20c508d6&scoped=true&"
import script from "./NPLRatio.vue?vue&type=script&lang=js&"
export * from "./NPLRatio.vue?vue&type=script&lang=js&"
import style0 from "./NPLRatio.vue?vue&type=style&index=0&id=20c508d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c508d6",
  null
  
)

export default component.exports